import {
  Box,
  Button,
  Collapse,
  Flex,
  HStack,
  Icon,
  Input,
  List,
  ListItem,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Portal,
  Select,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import {
  EventDetailsDto,
  GraduateDetailsDto,
  GraduateGuestDataDto,
  Props,
  TransferGraduateEntranceDto,
} from "../types";
import { ChevronTop } from "@/components/icons/topArrowIcon";
import { ChevronDown } from "@/components/icons/downArrowIcon";
import * as T from "@/components/table";
import { Footer } from "@/components/footer";
import InfiniteScroll from "react-infinite-scroll-component";
import { RoundTransferHorizontalLinear } from "@/components/icons/transferRounded";
import { CirclePlusOutline } from "@/components/icons/plusRounded";
import { MenuActionButton } from "@/components/menuActionButton";
import { Dispatch, useState } from "react";
import {
  Controller,
  ControllerProps,
  FieldErrors,
  SubmitHandler,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import { GuestFormData } from ".";

type MobileProps = {
  events: EventDetailsDto[];
  graduates: GraduateDetailsDto;
  register: UseFormRegister<GuestFormData>;
  control: ControllerProps<GuestFormData>["control"];
  handleSubmit: UseFormHandleSubmit<GuestFormData>;
  onSubmit: SubmitHandler<GuestFormData>;
  errors: FieldErrors<GuestFormData>;
  onCollapseToggle: () => void;
  isCollapseOpen: boolean;
  isTransferModal: boolean;
  onOpenTransferModal: () => void;
  onCloseTransfer: () => void;
  isOpenAddInvite: boolean;
  onCloseAddInvite: () => void;
  handleEditGuest: (guest: GraduateGuestDataDto) => void;
  handleNewGuest: () => void;
  registerTransfer: UseFormRegister<TransferGraduateEntranceDto>;
  handleSubmitTrasnfer: UseFormHandleSubmit<TransferGraduateEntranceDto>;
  onSubmitTransfer: SubmitHandler<TransferGraduateEntranceDto>;
  setValueTransfer: UseFormSetValue<TransferGraduateEntranceDto>;
  handleSendEmail: (id: number) => void;
  handleDownloadInvite: (id: number) => void;
  query: string;
  setQuery: Dispatch<React.SetStateAction<string>>;
  filtered: { id: number; name: string }[];
  handleCancelTransfer: () => void;
  handleDeleteGuest: (id: number) => void;
  handlePhoneChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: string) => void
  ) => void;
  phoneMask: (value: string) => string;
} & Props;

export const MobileContent = ({
  events,
  page,
  setPage,
  lastPage,
  graduates,
  register,
  handleSubmit,
  onSubmit,
  errors,
  onCollapseToggle,
  isCollapseOpen,
  isTransferModal,
  onOpenTransferModal,
  onCloseTransfer,
  isOpenAddInvite,
  onCloseAddInvite,
  handleEditGuest,
  handleNewGuest,
  registerTransfer,
  handleSubmitTrasnfer,
  onSubmitTransfer,
  setValueTransfer,
  handleSendEmail,
  handleDownloadInvite,
  query,
  setQuery,
  filtered,
  handleCancelTransfer,
  handleDeleteGuest,
  handlePhoneChange,
  phoneMask,
  control,
}: MobileProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [inviteSelected, setinviteSelected] = useState<any>();
  const [isBoxOpen, setIsBoxOpen] = useState(false);

  const formatedDate = (value?: string | Date) => {
    return value
      ? new Date(value).toLocaleString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "";
  };

  const heiht = events.length >= 0 ? {} : { h: "100%" };

  const inviteInfo = (inv: any) => {
    setinviteSelected(inv);
    onOpen();
  };

  return (
    <VStack
      bgColor="neutral.200"
      w="100%"
      flexDirection="column-reverse"
      {...heiht}
    >
      <Footer />
      <InfiniteScroll
        style={{ backgroundColor: "#EAEAEA", overflow: "hidden" }}
        dataLength={events.length}
        next={() => {
          setPage(page + 1);
        }}
        hasMore={page < lastPage}
        loader={<></>}
      >
        <Stack>
          <Stack p={3} w="100%" alignSelf="center">
            <Box
              borderWidth="2px"
              borderRadius="md"
              overflow="hidden"
              borderColor="neutral.300"
              width="100%"
            >
              <Flex
                p="4"
                align="center"
                justify="space-between"
                cursor="pointer"
                onClick={onCollapseToggle}
                bg="white"
              >
                <Text fontWeight="bold" fontSize="24px" color="secondary.500">
                  Informações do Evento
                </Text>
                <Icon
                  color="secondary.500"
                  as={isCollapseOpen ? ChevronTop : ChevronDown}
                />
              </Flex>
              <Collapse in={isCollapseOpen} animateOpacity>
                <Box p="5" bg="white">
                  <HStack p={2} bgColor="orange.100" borderRadius="md">
                    <Text fontWeight="semibold" minW="35%">
                      Nome Turma
                    </Text>
                    <Text>{graduates?.event.name}</Text>
                  </HStack>
                  <HStack p={2}>
                    <Text fontWeight="semibold" minW="35%">
                      Tipo Evento
                    </Text>
                    <Text>{graduates?.event.type.name}</Text>
                  </HStack>
                  <HStack p={2} bgColor="orange.100" borderRadius="md">
                    <Text fontWeight="semibold" minW="35%">
                      Data e Hora
                    </Text>
                    <Text>{formatedDate(graduates?.event.date)}</Text>
                  </HStack>
                  <HStack p={2}>
                    <Text fontWeight="semibold" minW="35%">
                      Local
                    </Text>
                    <Text>{graduates?.event.local}</Text>
                  </HStack>
                  <HStack p={2} bgColor="orange.100" borderRadius="md">
                    <Text fontWeight="semibold" minW="35%">
                      Endereço
                    </Text>
                    <Text>{graduates?.event.address}</Text>
                  </HStack>
                  <HStack p={2}>
                    <Text fontWeight="semibold" minW="35%">
                      Início Retirada
                    </Text>
                    <Text>
                      {formatedDate(graduates?.event.pickupInitialDate)}
                    </Text>
                  </HStack>
                  <HStack p={2} bgColor="orange.100" borderRadius="md">
                    <Text fontWeight="semibold" minW="35%">
                      Fim Retirada
                    </Text>
                    <Text>
                      {formatedDate(graduates?.event.pickupFinalDate)}
                    </Text>
                  </HStack>
                </Box>
              </Collapse>
            </Box>
          </Stack>
          <Stack p={3} w="100%" alignSelf="center">
            <Box
              borderWidth="2px"
              borderRadius="md"
              overflow="hidden"
              borderColor="neutral.300"
            >
              <Stack bgColor="white">
                <HStack p={4}>
                  <Text fontWeight="bold" fontSize="24px" color="secondary.500">
                    Informações do Formando
                  </Text>
                </HStack>
                <Stack p={4}>
                  <Stack>
                    <Text>Nome do Formando</Text>
                    <Input
                      h={12}
                      disabled
                      value={graduates?.name}
                      bgColor="neutral.200"
                      borderWidth={1}
                      borderColor="neutral.300"
                    />
                  </Stack>
                  {graduates?.entrancesRelation.map((ent) => {
                    const totalUsed = (graduates.guests ?? []).filter(
                      (guest) => guest.entrance.id === ent.eventEntrance.id
                    ).length;
                    return (
                      <Stack mt={2} key={ent.id}>
                        <Text>{ent.eventEntrance.type}</Text>
                        <Input
                          h={12}
                          disabled
                          value={`${totalUsed} / ${ent.quantityInvitation}`}
                          bgColor="neutral.200"
                          borderWidth={1}
                          borderColor="neutral.300"
                        />
                      </Stack>
                    );
                  })}
                </Stack>
              </Stack>
            </Box>
          </Stack>
          <Stack p={3} w="100%">
            <Stack p={2} w="100%" alignSelf="center">
              <HStack justifyContent="space-between">
                <Button
                  bgColor="secondary.500"
                  color="white"
                  w="47%"
                  _hover={{ bgColor: "secondary.300" }}
                  onClick={onOpenTransferModal}
                >
                  <RoundTransferHorizontalLinear color="white" />
                  <Text ml={1}>
                    Transferir <br /> Convite
                  </Text>
                </Button>
                <Button
                  bgColor="secondary.500"
                  color="white"
                  w="47%"
                  _hover={{ bgColor: "secondary.300" }}
                  onClick={handleNewGuest}
                >
                  <CirclePlusOutline color="white" />
                  <Text ml={1}>
                    Adicionar <br /> Convidado
                  </Text>
                </Button>
              </HStack>
              <Modal
                isOpen={isTransferModal}
                onClose={onCloseTransfer}
                closeOnOverlayClick={false}
                isCentered
              >
                <ModalOverlay />
                <ModalContent bgColor="neutral.100">
                  <form onSubmit={handleSubmitTrasnfer(onSubmitTransfer)}>
                    <ModalHeader>Transferir Convite</ModalHeader>
                    <ModalBody>
                      <Stack mt={1}>
                        <Text>Nome do Formando Transmissor</Text>
                        <Input
                          type="hidden"
                          value={graduates?.id}
                          {...registerTransfer("fromGraduateId", {
                            valueAsNumber: true,
                          })}
                        />
                        <Input
                          h={12}
                          value={graduates?.name}
                          disabled
                          bgColor="neutral.300"
                        />
                      </Stack>
                      <Stack mt={5}>
                        <Text>Nome do Formando Receptor</Text>
                        <Input
                          h={12}
                          placeholder="Insira o nome do formando receptor"
                          bgColor="white"
                          value={query}
                          onChange={(e) => {
                            setQuery(e.target.value);
                            setIsBoxOpen(true);
                          }}
                          onClickCapture={() => setIsBoxOpen(true)}
                        />
                        <Input
                          type="hidden"
                          {...registerTransfer("toGraduateId", {
                            valueAsNumber: true,
                          })}
                        />
                        {isBoxOpen &&
                          query.length > 0 &&
                          filtered.length > 0 && (
                            <List
                              position="absolute"
                              width="90%"
                              border="1px solid #ddd"
                              maxHeight="150px"
                              overflowY="auto"
                              zIndex={10}
                              mt={20}
                              borderRadius="md"
                              boxShadow="md"
                              bgColor="white"
                            >
                              {filtered.map((u) => (
                                <ListItem
                                  key={u.id}
                                  p={2}
                                  _hover={{ bg: "gray.100", cursor: "pointer" }}
                                  onClick={() => {
                                    setQuery(u.name);
                                    setValueTransfer("toGraduateId", u.id);
                                    setIsBoxOpen(false);
                                  }}
                                >
                                  <Text>{u.name}</Text>
                                </ListItem>
                              ))}
                            </List>
                          )}
                      </Stack>
                      <Stack mt={5}>
                        <Text>Lote</Text>
                        <Select
                          bgColor="white"
                          h={12}
                          {...registerTransfer("entranceId")}
                        >
                          <option value="">Selecione</option>
                          {graduates?.entrancesRelation.map((ent) => (
                            <option key={ent.id} value={ent.eventEntrance.id}>
                              {ent.eventEntrance.type}
                            </option>
                          ))}
                        </Select>
                      </Stack>
                      <Stack mt={5}>
                        <Text>Quantidade</Text>
                        <Input
                          h={12}
                          type="number"
                          placeholder="Insira a quantidade"
                          bgColor="white"
                          {...registerTransfer("quantity")}
                        />
                      </Stack>
                      <Stack mt={5}>
                        <Stack w="100%">
                          <Button
                            type="submit"
                            color="white"
                            bgColor="secondary.500"
                            _hover={{ bgColor: "secondary.300" }}
                            h={20}
                          >
                            Confirmar
                          </Button>
                        </Stack>
                        <Stack w="100%" mt={2}>
                          <Button
                            onClick={handleCancelTransfer}
                            border="1px"
                            borderColor="secondary.500"
                            bgColor="white"
                            color="secondary.500"
                            _hover={{
                              bgColor: "secondary.300",
                              borderColor: "secondary.300",
                              color: "white",
                            }}
                            h={20}
                          >
                            Cancelar
                          </Button>
                        </Stack>
                      </Stack>
                    </ModalBody>
                  </form>
                </ModalContent>
              </Modal>
              <Modal
                isOpen={isOpenAddInvite}
                onClose={onCloseAddInvite}
                isCentered
              >
                <ModalOverlay />
                <ModalContent bgColor="neutral.100">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <ModalHeader>Adicionar Convidado</ModalHeader>
                    <ModalBody>
                      <Stack mt={1}>
                        <Text>Lote</Text>
                        <Select
                          bgColor="white"
                          h={12}
                          {...register("entranceId")}
                        >
                          <option value="">Selecione</option>
                          {graduates?.entrancesRelation.map((ent) => (
                            <option key={ent.id} value={ent.eventEntrance.id}>
                              {ent.eventEntrance.type}
                            </option>
                          ))}
                        </Select>
                        {errors?.entranceId?.message && (
                          <Text
                            fontFamily="Lato"
                            fontStyle="normal"
                            fontWeight="500"
                            fontSize="11px"
                            lineHeight="18px"
                            color="fail.500"
                          >
                            {errors.entranceId.message}
                          </Text>
                        )}
                      </Stack>
                      <Stack mt={5}>
                        <Text>Nome do Convidado</Text>
                        <Input
                          h={12}
                          placeholder="Insira o nome do convidado"
                          bgColor="white"
                          {...register("name")}
                        />
                        {errors?.name?.message && (
                          <Text
                            fontFamily="Lato"
                            fontStyle="normal"
                            fontWeight="500"
                            fontSize="11px"
                            lineHeight="18px"
                            color="fail.500"
                          >
                            {errors.name.message}
                          </Text>
                        )}
                      </Stack>
                      <Stack mt={5}>
                        <Text>E-mail</Text>
                        <Input
                          h={12}
                          type="email"
                          placeholder="Insira o e-mail do convidado"
                          bgColor="white"
                          {...register("email")}
                        />
                        {errors?.email?.message && (
                          <Text
                            fontFamily="Lato"
                            fontStyle="normal"
                            fontWeight="500"
                            fontSize="11px"
                            lineHeight="18px"
                            color="fail.500"
                          >
                            {errors.email.message}
                          </Text>
                        )}
                      </Stack>
                      <Stack mt={5}>
                        <Text>Telefone</Text>
                        <Controller
                          name="phone"
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <Input
                              h={12}
                              type="tel"
                              placeholder="Insira o telefone do convidado"
                              bgColor="white"
                              value={value}
                              onChange={(e) => handlePhoneChange(e, onChange)}
                            />
                          )}
                        />
                        {errors?.phone?.message && (
                          <Text
                            fontFamily="Lato"
                            fontStyle="normal"
                            fontWeight="500"
                            fontSize="11px"
                            lineHeight="18px"
                            color="fail.500"
                          >
                            {errors.phone.message}
                          </Text>
                        )}
                      </Stack>
                      <Stack mt={5}>
                        <Stack w="100%">
                          <Button
                            type="submit"
                            color="white"
                            bgColor="secondary.500"
                            _hover={{ bgColor: "secondary.300" }}
                            h={20}
                          >
                            Confirmar
                          </Button>
                        </Stack>
                        <Stack w="100%">
                          <Button
                            onClick={onCloseAddInvite}
                            border="1px"
                            borderColor="secondary.500"
                            bgColor="white"
                            color="secondary.500"
                            _hover={{
                              bgColor: "secondary.300",
                              borderColor: "secondary.300",
                              color: "white",
                            }}
                            h={20}
                          >
                            Cancelar
                          </Button>
                        </Stack>
                      </Stack>
                    </ModalBody>
                  </form>
                </ModalContent>
              </Modal>
            </Stack>
          </Stack>
          <Stack p={3} mb="120px">
            <Table>
              <Thead bgColor="neutral.300">
                <Tr>
                  <Th>
                    <Text fontWeight="semibold" color="black" fontSize="14px">
                      Convidado
                    </Text>
                  </Th>
                  <Th>
                    <Text fontWeight="semibold" color="black" fontSize="14px">
                      Lote
                    </Text>
                  </Th>
                  <Th>
                    <Text fontWeight="semibold" color="black" fontSize="14px">
                      Ações
                    </Text>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {graduates?.guests.map((inv) => (
                  <T.Body key={inv.id}>
                    <Td>
                      <Text>{inv.name}</Text>
                    </Td>
                    <Td>
                      <Text>{inv.entrance.type}</Text>
                    </Td>
                    <Td>
                      <Menu key={inv.id}>
                        <MenuButton>
                          <MenuActionButton color="black" onClick={() => ""} />
                        </MenuButton>
                        <Portal>
                          <MenuList
                            border="1px solid #2F2F2F"
                            marginRight={3}
                            marginTop="-35px"
                          >
                            <MenuItem
                              fontWeight="500"
                              onClick={() => inviteInfo(inv)}
                            >
                              <Box
                                as="span"
                                w="6px"
                                h="6px"
                                borderRadius="full"
                                bg="#2F2F2F"
                                marginRight={4}
                              />
                              Visualizar
                            </MenuItem>
                            <MenuItem
                              fontWeight="500"
                              onClick={() => handleSendEmail(inv.id)}
                            >
                              <Box
                                as="span"
                                w="6px"
                                h="6px"
                                borderRadius="full"
                                bg="#2F2F2F"
                                marginRight={4}
                              />
                              Enviar 2º via por E-mail
                            </MenuItem>
                            <MenuItem
                              fontWeight="500"
                              onClick={() => handleDownloadInvite(inv.id)}
                            >
                              <Box
                                as="span"
                                w="6px"
                                h="6px"
                                borderRadius="full"
                                bg="#2F2F2F"
                                marginRight={4}
                              />
                              Baixar
                            </MenuItem>
                            <MenuItem
                              fontWeight="500"
                              onClick={() => handleEditGuest(inv)}
                              isDisabled={inv.wasSent}
                            >
                              <Box
                                as="span"
                                w="6px"
                                h="6px"
                                borderRadius="full"
                                bg="#2F2F2F"
                                marginRight={4}
                              />
                              Editar
                            </MenuItem>
                            <MenuItem
                              fontWeight="500"
                              onClick={() => handleDeleteGuest(inv.id)}
                              isDisabled={inv.isPresent || inv.isGraduate}
                            >
                              <Box
                                as="span"
                                w="6px"
                                h="6px"
                                borderRadius="full"
                                bg="#2F2F2F"
                                marginRight={4}
                              />
                              Excluir
                            </MenuItem>
                          </MenuList>
                        </Portal>
                      </Menu>
                    </Td>
                  </T.Body>
                ))}
              </Tbody>
            </Table>
            <Modal isOpen={isOpen} onClose={onClose}>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader color="secondary.500">
                  Dados do Convidado
                </ModalHeader>
                <ModalCloseButton color="secondary.500" />
                <ModalBody>
                  {inviteSelected && (
                    <Stack spacing={2}>
                      <Stack>
                        <Text>Nome do Formando</Text>
                        <Input
                          h={12}
                          disabled
                          value={graduates?.name}
                          bgColor="neutral.200"
                          borderWidth={1}
                          borderColor="neutral.300"
                        />
                      </Stack>
                      <Stack>
                        <Text>E-mail</Text>
                        <Input
                          h={12}
                          disabled
                          value={inviteSelected.email}
                          bgColor="neutral.200"
                          borderWidth={1}
                          borderColor="neutral.300"
                        />
                      </Stack>
                      <Stack>
                        <Text>Telefone</Text>
                        <Input
                          h={12}
                          disabled
                          value={phoneMask(inviteSelected.phone)}
                          bgColor="neutral.200"
                          borderWidth={1}
                          borderColor="neutral.300"
                        />
                      </Stack>
                      <Stack>
                        <Text>Lote</Text>
                        <Input
                          h={12}
                          disabled
                          value={inviteSelected.entrance.type}
                          bgColor="neutral.200"
                          borderWidth={1}
                          borderColor="neutral.300"
                        />
                      </Stack>
                      <Stack mb={5}>
                        <Text>Retirada</Text>
                        <Input
                          h={12}
                          disabled
                          value={`${
                            inviteSelected.invitationSentAt
                              ? new Date(
                                  inviteSelected.invitationSentAt
                                ).toLocaleString("pt-BR", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                              : "Ainda não retirado"
                          }`}
                          bgColor="neutral.200"
                          borderWidth={1}
                          borderColor="neutral.300"
                        />
                      </Stack>
                    </Stack>
                  )}
                </ModalBody>
              </ModalContent>
            </Modal>
          </Stack>
        </Stack>
      </InfiniteScroll>
    </VStack>
  );
};
